/* eslint-disable */
import { MessageBox } from 'element-ui'

/* @description CSharp Client 基类, 将插件提供的所有接口暴露给JS*/
class ICSharpClient {
  /* @description 构造函数*/

  constructor() {}
  /*
  @desciption 设置错误处理回调函数
  @params errorHandler:Function 错误处理回调函数, 其签名为: (errorCode:String, errorMessage:String) -> void
  @
  @return void
  */
  SetErrorHandler(errorHandler) {
    this.errorHandler = errorHandler
  }

  /*
  @desciption 检查response是否有错误, 若有则调用错误处理回调函数
  @params response ICSharpClient接口的响应结果
  @
  @return <response>
  */
  __FilterError(response) {
    if (response.code === 'success') {
      return response
    }
    if (typeof this.errorHandler === 'undefined' || this.errorHandler == null) {
      return response
    }

    this.errorHandler(response.code, response.message)
    return response
  }

  /*
  @desciption 获取插件提供的所有接口的默认响应结果
  @params void
  @
  @return 插件提供的所有接口的默认响应结果
  */
  #DefaultResponse() {
    return new Promise((resolve) => {
      resolve(this.__FilterError({
        code: 'request.method.not.found',
        message: 'not implemented!',
        data: null
      }))
    })
  }

  /*
  @desciption 调用C#接口，通用入口
  @params method:String 要调用的C#函数签名
  @params params:Object C#函数所需的参数
  @
  @return a Promise. resolve 的结果为：
      {
          code: String,
          message: String,
          data: <data>
      }
      code 为success表示成功
      data 为实际执行结果
  */
  CallCSharp(method, params) { return this.#DefaultResponse() }
  /*
  @description 调用C#，打开默认浏览器跳转到指定链接
  @params targetUrl:String 要打开的目标链接
  @params auth:Bool 打开链接时是否携带登录信息
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  NavigateToBrowser(targetUrl, auth = false) { return this.#DefaultResponse() }
  /*
  @description 调用C#, 获取access token
  @params void
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: String
      }
      code - 为success表示成功
      data - access token
  */
  GetAccessToken() { return this.#DefaultResponse() }
  /*
  @description 调用C#，获取用户信息
  @params void
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: Object
      }
      code - 为success表示成功
      data - 用户信息，其结构为：
      {
        email: string,
        id: string,
        mobile: string,
        name: string
      }
  */
  GetUserInfo() { return this.#DefaultResponse() }
  /*
  @description 调用C#，获取桌面端基本信息
  @params void
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: Object
      }
      code - 为success表示成功
      data - 桌面端基本信息，其结构为：
      {
        clientType: string,
        hostAppName: string,
        hostAppVersion: string,
        pluginName: string,
        pluginVersion: string,
        machineCode: string,
        osVersion: string,
        screenResolutions: string
      }
  */
  GetDesktopInfo() { return this.#DefaultResponse() }
  /*
  @description 调用C#，发送埋点
  @params eventName:String 事件名称
  @params eventParams:Object 事件参数对象
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  Track(eventName, eventParams) { return this.#DefaultResponse() }
  /*
  @description 调用C#，获取项目信息
  @params void
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: Object
      }
      code - 为success表示成功
      data - 项目信息，其结构为：
      {
        id: String,
        name: String,
        path: String
      }
  */
  GetProjectInfo() { return this.#DefaultResponse() }
  /*
  @description 调用C#，检测用户是否已登录
  @params void
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: Bool
      }
      code - 为success表示成功
      data - 若已登录, 则返回true; 否则, 则返回false
  */
  IsUserLoggedIn() { return this.#DefaultResponse() }
  /*
  @description 调用C#，弹出登录对话框
  @params void
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ShowLoginDialog() { return this.#DefaultResponse() }
  /*
  @description 调用C#，布置产品关联构件
  @params productComponentPlacingData:Object, 产品构件布置数据，其结构为：
      {
        publicComponentId:String, 要布置的公共构件ID
        publicComponentVersion:String, 要布置的公共构件版本
        publicComponentName:String, 要布置的公共构件名称
        familyTypeToBePlaced:String, 要布置的构件类型名称
        sharedParameters: [
          {
            dataCategory: String, 参数类别
            dataType: String, 参数类型
            description: String, 描述
            groupId: Integer, 分组ID
            groupName: String, 分组名称
            guid: String, 参数GUID
            isInstance: Bool, 是否实例参数
            name: String, 参数名称
            userModifiable: Bool, 用户是否可修改
            visible: Bool, 是否可见
            value: String 参数值
          }
        ]
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  PlaceProductComponent(productComponentPlacingData) { return this.#DefaultResponse() }
}

/* @description CSharp Client 扩展类, 适配产品库诞生之前的插件版本*/
class CSharpClient_None extends ICSharpClient {
  /* @description 构造函数*/
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super()
  }
}

/* @description CSharp Client 扩展类, 适配3.5.78.0之后的插件版本(产品库诞生之初)*/
class CSharpClient_After_3_5_78_0 extends ICSharpClient {
  /* @description 构造函数*/
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super()
  }

  /* @description 确保interop对象已绑定*/
  async __EnsureCefSharpObjectBound() {
    if (typeof interop !== 'undefined') {
      return
    }

    try {
      /* 对于高版本CefSharp库, 须执行此语句, 低版本CefSharp执行此语句会出错, 为了兼容, 这里在try catch内进行调用 */
      // eslint-disable-next-line no-undef
      await CefSharp.BindObjectAsync('interop')
    } catch (e) {
      /* ignored */
    }
  }

  /* @description 接口实现*/
  async NavigateToBrowser(targetUrl, auth = false) {
    await this.__EnsureCefSharpObjectBound()
    if (typeof interop === 'undefined') {
      return this.__FilterError({
        code: 'failure',
        message: 'interop is undefined!',
        data: null
      })
    }

    // eslint-disable-next-line no-undef
    await interop.NavigateToBrowser(targetUrl, auth)

    return this.__FilterError({
      code: 'success',
      message: 'OK',
      data: null
    })
  }

  /* @description 接口实现*/
  async GetAccessToken() {
    await this.__EnsureCefSharpObjectBound()
    if (typeof interop === 'undefined') {
      return this.__FilterError({
        code: 'failure',
        message: 'interop is undefined!',
        data: null
      })
    }

    // eslint-disable-next-line no-undef
    const accessToken = await interop.GetAccessToken()

    return this.__FilterError({
      code: 'success',
      message: 'OK',
      data: accessToken
    })
  }

  /* @description 接口实现*/
  async GetUserInfo() {
    await this.__EnsureCefSharpObjectBound()
    if (typeof interop === 'undefined') {
      return this.__FilterError({
        code: 'failure',
        message: 'interop is undefined!',
        data: null
      })
    }

    // eslint-disable-next-line no-undef
    const userInfoStr = await interop.GetUserInfo()

    return this.__FilterError({
      code: 'success',
      message: 'OK',
      data: JSON.parse(userInfoStr)
    })
  }

  /* @description 接口实现*/
  async GetDesktopInfo() {
    await this.__EnsureCefSharpObjectBound()
    if (typeof interop === 'undefined') {
      return this.__FilterError({
        code: 'failure',
        message: 'interop is undefined!',
        data: null
      })
    }

    // eslint-disable-next-line no-undef
    const desktopInfoStr = await interop.GetDesktopInfo()

    return this.__FilterError({
      code: 'success',
      message: 'OK',
      data: JSON.parse(desktopInfoStr)
    })
  }

  /* @description 接口实现*/
  async Track(eventName, eventParams) {
    await this.__EnsureCefSharpObjectBound()
    if (typeof interop === 'undefined') {
      return this.__FilterError({
        code: 'failure',
        message: 'interop is undefined!',
        data: null
      })
    }
    // eslint-disable-next-line no-undef
    await interop.Track(eventName, JSON.stringify(eventParams))

    return this.__FilterError({
      code: 'success',
      message: '',
      data: null
    })
  }
}

/* @description CSharp Client 扩展类, 适配3.6.8.36之后的插件版本(产品库新增布置功能)*/
class CSharpClient_After_3_6_8_36 extends CSharpClient_After_3_5_78_0 {
  /* @description 构造函数*/
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super()
  }

  /* @description 接口实现*/
  async GetProjectInfo() {
    await this.__EnsureCefSharpObjectBound()
    if (typeof interop === 'undefined') {
      return this.__FilterError({
        code: 'failure',
        message: 'interop is undefined!',
        data: null
      })
    }
    const projectInfoStr = await interop.GetProjectInfo()

    return this.__FilterError({
      code: 'success',
      message: '',
      data: JSON.parse(projectInfoStr)
    })
  }

  /* @description 接口实现*/
  async IsUserLoggedIn() {
    await this.__EnsureCefSharpObjectBound()
    if (typeof interop === 'undefined') {
      return this.__FilterError({
        code: 'failure',
        message: 'interop is undefined!',
        data: null
      })
    }
    // eslint-disable-next-line no-undef
    const isUserLoggedIn = await interop.IsUserLoggedIn()

    return this.__FilterError({
      code: 'success',
      message: '',
      data: isUserLoggedIn
    })
  }

  /* @description 接口实现*/
  async ShowLoginDialog() {
    await this.__EnsureCefSharpObjectBound()
    if (typeof interop === 'undefined') {
      return this.__FilterError({
        code: 'failure',
        message: 'interop is undefined!',
        data: null
      })
    }
    // eslint-disable-next-line no-undef
    await interop.ShowLoginDialog()

    return this.__FilterError({
      code: 'success',
      message: '',
      data: null
    })
  }

  /* @description 接口实现*/
  async PlaceProductComponent(productComponentPlacingData) {
    await this.__EnsureCefSharpObjectBound()
    if (typeof interop === 'undefined') {
      return this.__FilterError({
        code: 'failure',
        message: 'interop is undefined!',
        data: null
      })
    }
    // eslint-disable-next-line no-undef
    await interop.PlaceProductComponent(
        productComponentPlacingData.publicComponentId,
        productComponentPlacingData.publicComponentVersion,
        productComponentPlacingData.familyTypeToBePlaced)

    return this.__FilterError({
      code: 'success',
      message: '',
      data: null
    })
  }
}

/* @description CSharp Client 扩展类, 适配3.6.12.0之后的插件版本(产品库新增写入设计值功能)*/
class CSharpClient_After_3_6_12_0 extends ICSharpClient {
  /* @description 构造函数*/
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super()
  }

  /* @description 确保interop对象已绑定*/
  async __EnsureCefSharpObjectBound() {
    if (typeof CefClient !== 'undefined') {
      return
    }

    try {
      /* 对于高版本CefSharp库, 须执行此语句, 低版本CefSharp执行此语句会出错, 为了兼容, 这里在try catch内进行调用 */
      // eslint-disable-next-line no-undef
      await CefSharp.BindObjectAsync('CefClient')
    } catch (e) {
      /* ignored */
    }
  }

  /* @description 接口实现*/
  async CallCSharp(method, params) {
    try {
      await this.__EnsureCefSharpObjectBound()
      if (typeof CefClient === 'undefined') {
        return this.__FilterError({
          code: 'failure',
          message: 'CefClient is undefined!',
          data: null
        })
      }

      const requestObj = {
        path: method,
        params: params
      }

      // eslint-disable-next-line no-undef
      const responseStr = await CefClient.Send(JSON.stringify(requestObj))
      return this.__FilterError(JSON.parse(responseStr))
    } catch (e) {
      return this.__FilterError({
        code: 'failure',
        message: e.toString(),
        data: null
      })
    }
  }

  /* @description 接口实现*/
  async NavigateToBrowser(targetUrl, auth = false) {
    const method = 'gjw/revit/common/v1/navigate_to_browser'
    const params = {
      targetUrl: targetUrl,
      auth: auth
    }

    return await this.CallCSharp(method, params)
  }

  /* @description 接口实现*/
  async GetAccessToken() {
    const method = 'gjw/revit/account/v1/access_token'
    const params = {}

    return await this.CallCSharp(method, params)
  }

  /* @description 接口实现*/
  async GetUserInfo() {
    const method = 'gjw/revit/account/v1/user_info'
    const params = {}

    return await this.CallCSharp(method, params)
  }

  /* @description 接口实现*/
  async GetDesktopInfo() {
    const method = 'gjw/revit/common/v1/desktop_info'
    const params = {}

    return await this.CallCSharp(method, params)
  }

  /* @description 接口实现*/
  async Track(eventName, eventParams) {
    const method = 'gjw/revit/common/v1/track'
    const params = {
      eventName: eventName,
      eventParams: eventParams
    }

    return await this.CallCSharp(method, params)
  }

  /* @description 接口实现*/
  async GetProjectInfo() {
    const method = 'gjw/revit/common/v1/project_info'
    const params = {}

    return await this.CallCSharp(method, params)
  }

  /* @description 接口实现*/
  async IsUserLoggedIn() {
    const method = 'gjw/revit/account/v1/is_user_logged_in'
    const params = {}

    return await this.CallCSharp(method, params)
  }

  /* @description 接口实现*/
  async ShowLoginDialog() {
    const method = 'gjw/revit/view/v1/show_login_dialog'
    const params = {}

    return await this.CallCSharp(method, params)
  }

  /* @description 接口实现*/
  async PlaceProductComponent(productComponentPlacingData) {
    const method = 'gjw/revit/product/v2/place'
    const params = {
      productComponentPlacingData: productComponentPlacingData
    }

    return await this.CallCSharp(method, params)
  }
}

/* @description CSharp Client 工厂类, 自动根据插件版本号, 创建对应的CSharp Client实例*/
class CSharpClientFactory {
  /* @description 构造函数*/
  constructor() {
    this.availableClientTypes = [
      { afterVersion: '0.0.0.0', clientType: CSharpClient_None },
      { afterVersion: '3.5.78.0', clientType: CSharpClient_After_3_5_78_0 },
      { afterVersion: '3.6.8.36', clientType: CSharpClient_After_3_6_8_36 },
      { afterVersion: '3.6.12.0', clientType: CSharpClient_After_3_6_12_0 }
    ] // 版本号须按递增顺序
  }

  static #_factory = null;
  /* @description CSharpClientFactory工厂单例*/
  static get Factory() {
    if (!this.#_factory) {
      this.#_factory = new CSharpClientFactory()
    }

    return this.#_factory
  }

  /*
  @desciption 将插件版本号拆分为4位数字
  @params version:String 插件版本号
  @
  @return versionParts:Int[4]. 点分版本号数组, 元素类型为Integer, 数组长度为4
  */
  #SplitPluginVersion(version) {
    let adjustedVersion = version.trim()

    // 处理带'V'的老版本号
    if (adjustedVersion.startsWith('V')) {
      adjustedVersion = adjustedVersion.substring(1).trim()
    }

    const versionNumbers = []
    const versionParts = adjustedVersion.split('.')
    const count = versionParts.length
    for (let i = 0; i < count; ++i) {
      versionNumbers.push(parseInt(versionParts[i]))
    }

    // 补齐版本号为4位
    for (let i = count; i < 4; ++i) {
      versionNumbers.push(0)
    }

    return versionNumbers
  }

  /*
  @desciption 比较插件版本号
  @params version1:String 插件版本号1
  @params version2:String 插件版本号2
  @
  @return an Integer. 若version1 > version2, 则返回正数; 若version1 < version2, 则返回负数; 否则返回0
  */
  // eslint-disable-next-line no-dupe-class-members
  #ComparePluginVersion(version1, version2) {
    const version1Numbers = this.#SplitPluginVersion(version1)
    const version2Numbers = this.#SplitPluginVersion(version2)

    if (version1Numbers.length !== 4 || version2Numbers.length !== 4) {
      // eslint-disable-next-line no-throw-literal
      throw 'size of plugin version numbers must be 4!'
    }

    for (let i = 0; i < 4; ++i) {
      if (version1Numbers[i] > version2Numbers[i]) {
        return 1
      }

      if (version1Numbers[i] < version2Numbers[i]) {
        return -1
      }
    }

    return 0
  }

  /*
  @desciption 获取或创建ICSharpClient实例对象
  @params void
  @
  @return ICSharpClient实例对象
  */
  async GetClient() {
    let pluginVersion = '-.-.-.-'
    if (typeof this.client === 'undefined' || this.client === null) {
      for (let i = this.availableClientTypes.length - 1; i >= 0; --i) {
        const afterVersion = this.availableClientTypes[i].afterVersion
        // eslint-disable-next-line new-cap
        const availableClient = new this.availableClientTypes[i].clientType()

        const desktopInfoResult = await availableClient.GetDesktopInfo()
        if (desktopInfoResult.code !== 'success') {
          continue
        }

        pluginVersion = desktopInfoResult.data.pluginVersion
        if (this.#ComparePluginVersion(pluginVersion, afterVersion) > 0) {
          this.client = availableClient
          console.info(`plugin version:'${pluginVersion}', CSharpClient created from Type '${this.availableClientTypes[i].clientType.name}'`)
          break
        }
      }
    }

    if (typeof this.client === 'undefined' || this.client === null) {
      this.client = new CSharpClient_None()
      console.info(`plugin version:'${pluginVersion}', CSharpClient created from Type '${CSharpClient_None.name}'`)
    }
    return this.client
  }
}

// 创建revit类实例
async function InitRevitClient() {
  // 向ICSharpClient实例注册错误处理回调
  const csharpClient = await CSharpClientFactory.Factory.GetClient()
  csharpClient.SetErrorHandler((errorCode) => {
    if (errorCode === 'request.method.not.found') {
      MessageBox.confirm('您的插件版本可能较低, 建议升级后使用此功能！', '提示', {
        type: 'warning',
        showCancelButton: false
      })
    }
  })
  return csharpClient
}

export {
  InitRevitClient
}

